import * as React from "react";
import { ColumnProps } from '../../../../components/DataGrid/CellColumnProps';
import { Button } from '../../../../components/Buttons';

interface ButtonColumnProps extends ColumnProps
{
    title: string;
    onClick: (datum: any, row: number) => void;
}

// This column renders a button inside a cell
// Mostly it is used for Action column in a grid
export class DataGridButtonColumn extends React.Component<ButtonColumnProps, null>
{
    render ()
    {
        const { datum, row, title, onClick, cellClassName } = this.props;
        return (
            <td className={cellClassName}>
                <Button dim="xs" type="info" leftIcon="pencil" onClick={e => onClick(datum, row)}>{title}</Button>
            </td>
         );
    }
}



// WEBPACK FOOTER //
// ./src/app/components/Pages/Columns/DataGridButtonColumn.tsx